import type {
  AppEmbed,
  ConversationEmbed,
  LiveboardEmbed,
  SageEmbed,
  SearchBarEmbed,
  SearchEmbed,
} from '@thoughtspot/visual-embed-sdk';
import { HostEvent } from '@thoughtspot/visual-embed-sdk';
import { useState } from 'react';
import { logError } from 'shared/lib/log-errors';
import type { Tab } from 'shared/ui/NavigationTabs';
import { NavigationTabs } from 'shared/ui/NavigationTabs';

export interface EmbedTabs {
  orderedTabIds: string[];
  numberOfTabs: number;
  Tabs: {
    __typename: string;
    containerIds: string[];
    id: string;
    name: string;
  }[];
}

type ReportTabsProps = {
  className?: string;
  embedTabs?: EmbedTabs;
  embedRef?: React.MutableRefObject<
    LiveboardEmbed | SearchEmbed | AppEmbed | SearchBarEmbed | SageEmbed | ConversationEmbed
  >;
};

export function ReportTabs({ className, embedTabs, embedRef }: ReportTabsProps) {
  const [currentTab, setCurrentTab] = useState(0);

  const tabs: Tab[] =
    embedTabs?.orderedTabIds.map((id, i) => {
      return {
        id: i,
        text: embedTabs.Tabs.find((tab) => tab.id === id)?.name ?? '',
        onClick: () => {
          embedRef?.current
            .trigger(HostEvent.SetActiveTab, {
              tabId: id,
            })
            .catch(logError);

          setCurrentTab(i);
        },
      };
    }) ?? [];

  return (
    <div className={className}>
      <NavigationTabs
        tabs={tabs}
        selectedId={currentTab}
      />
    </div>
  );
}
